module.exports = __webpack_public_path__ + "static/media/arturo.19b78da4.png";